module.exports = __webpack_public_path__ + "img/first-noticehome.9616bbf6.png";